import { LoadingSpinner } from "@/components/loading-spinner";
import { H2 } from "@/components/typography";

import { DataTable } from "../../components/data-table";
import { columnsA, columnsB, columnsC, columnsD } from "./columns";

import { addRangeFields } from "./ranges";

type EfficiencyTablesProps = {
  data?: any;
  error?: any;
  isMutating?: any;
};

const decimalFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  maximumSignificantDigits: 3,

  notation: "compact",
  compactDisplay: "short",
});

function EfficiencyTables({ data, error, isMutating }: EfficiencyTablesProps): JSX.Element {
  if (isMutating) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div>Error: {JSON.stringify(error.serverError)}</div>;
  }

  if (!data) {
    return <p className="text-muted-foreground">Run the analysis above.</p>;
  }

  if (!data.results || data.results.length == 0) {
    return <p>There is no data for the selected filters. Try again with other combinations</p>;
  }

  data.results = addRangeFields(data.results);

  return (
    <>
      {data.meta && (
        <p>
          Query completed in {decimalFormatter.format(data.meta.Took / 1e9)} seconds, processed{" "}
          {decimalFormatter.format(data.meta.TotalBytesProcessed / 1e9)} GB which cost{" "}
          {usdFormatter.format(data.meta.CostUSD)}.
        </p>
      )}

      <H2>Win Rates</H2>
      <DataTable columns={columnsA} data={data.results} />

      <H2>Impression Value, Max Bid, Bid Price</H2>
      <DataTable columns={columnsB} data={data.results} />

      {(data.params.campaign_type === "install" || data.params.campaign_type === "ctv_install") && (
        <>
          <H2>Predicted and Actual Install Rates</H2>
          <DataTable columns={columnsC} data={data.results} />
        </>
      )}

      <H2>Revenue, Profit and Infrastructure Cost</H2>
      <DataTable columns={columnsD} data={data.results} />
    </>
  );
}

export default EfficiencyTables;
